import { render, staticRenderFns } from "./ClassroomOrderSlidebar.vue?vue&type=template&id=7c7812c0"
import script from "./ClassroomOrderSlidebar.vue?vue&type=script&lang=js"
export * from "./ClassroomOrderSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports